import styled from 'styled-components'

import ActionButton from '../ActionButton'

export const Container = styled.div``

export const Title = styled.p`
  width: 100%;
  ${({ theme }) => theme.textStyles.display};
  text-align: center;
`

export const FieldTitle = styled.p`
  width: 100%;
  ${({ theme }) => theme.fonts.BBCondBold};
  font-size: 12px;
  text-align: center;
  text-transform: uppercase;
  margin-top: 36px;
`

export const FieldDescription = styled.p`
  margin-top: 4px;
  width: 100%;
  text-align: center;
  ${({ theme }) => theme.textStyles.body};
`

export const Center = styled.div`
  display: flex;
  justify-content: center;
`

export const Button = styled(ActionButton)`
  display: inline-flex;
  margin: 30px auto auto auto;
`
